import { Flow } from "../types";
import { SCREENS } from "../screens";
import { isFinishContract, shouldCollectGDPRAgreements } from "@/utils/contract";
import { Contract } from "@/types/contract";
import { isCustomerIdentified } from "../helpers";

export const VRB_SELF_SERVICE: Flow = {
  [SCREENS.WELCOME]: {
    next: (contract: Contract) => (isCustomerIdentified(contract) ? SCREENS.CUSTOMER : SCREENS.IDENTIFICATION),
    back: () => null,
  },
  [SCREENS.IDENTIFICATION]: {
    next: () => SCREENS.CUSTOMER,
    back: () => SCREENS.WELCOME,
  },
  [SCREENS.CUSTOMER]: {
    next: () => SCREENS.PRODUCTION_POINT,
    back: (contract: Contract) => (isCustomerIdentified(contract) ? SCREENS.IDENTIFICATION : SCREENS.WELCOME),
  },
  [SCREENS.PRODUCTION_POINT]: {
    next: () => SCREENS.PAYMENTS,
    back: () => SCREENS.CUSTOMER,
  },
  [SCREENS.PAYMENTS]: {
    next: () => SCREENS.RECAPITULATION,
    back: () => SCREENS.PRODUCTION_POINT,
  },
  [SCREENS.RECAPITULATION]: {
    next: (contract: Contract, options?: { gdprAgreed?: boolean; isContractRequest?: boolean }) => {
      if (!options?.gdprAgreed && shouldCollectGDPRAgreements(contract, options?.isContractRequest ?? false)) {
        return SCREENS.AGREEMENTS;
      }
      if (isFinishContract(contract)) {
        return SCREENS.THANK_YOU;
      }
      return SCREENS.VIEW;
    },
    back: () => SCREENS.PAYMENTS,
  },
  [SCREENS.AGREEMENTS]: {
    next: (contract: Contract) => (isFinishContract(contract) ? SCREENS.THANK_YOU : SCREENS.VIEW),
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.VIEW]: {
    next: () => SCREENS.SIGNATURE,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.SIGNATURE]: {
    next: () => SCREENS.SMS_CODE,
    back: () => SCREENS.VIEW,
  },
  [SCREENS.SIGNATURE_ON_PHONE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => null,
  },
  [SCREENS.SMS_CODE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => SCREENS.SIGNATURE,
  },
  [SCREENS.THANK_YOU]: {
    next: () => null,
    back: () => null,
  },
};
